import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface BenefitsCalculatorState {
  /** Messages whose answers the care profile didn't accept. */
  rejectedMessageIds: string[];
}

const initialState: BenefitsCalculatorState = { rejectedMessageIds: [] };

export const benefitsCalculatorSlice = createSlice({
  name: 'benefitsCalculator',
  initialState,
  reducers: {
    answersRejected: (state, { payload }: PayloadAction<string>) => {
      if (!state.rejectedMessageIds.includes(payload)) {
        state.rejectedMessageIds.push(payload);
      }
    },
  },
});

export const { answersRejected } = benefitsCalculatorSlice.actions;

export const getRejectedMessageIds = (state: {
  benefitsCalculator: BenefitsCalculatorState;
}) => state.benefitsCalculator.rejectedMessageIds;

export default benefitsCalculatorSlice.reducer;
